module.exports = __webpack_public_path__ + "img/UT0399.926b2959.png";